import { Http } from '@/lib/http';

export class DelinquencyCollateralAssignment extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/app/delinquency-collateral-assignments';
  }

/**
 * @param {Object} payload - The filter object that contains information for the assignment.
 * @param {string} payload.collateralId - The id of the collateral.
 * @param {string} payload.externalParticipantId - The id of the external participant.
 * @param {Object} payload.information
 */
  assignDelinquencyCollateral(payload) {
    return this.httpClient().post(
      `${this.endpoint}`,
      payload
    );
  }

  findDelinquencyCollateralAssignmentByCollateralId(payload) {
    return this.httpClient().post(
      `${this.endpoint}/find`,
      payload
    );
  }

  /**
   * This updates the collateral assignment
   *
   * Used when editing additional information for Bailiff, Collector
   */
  updateDelinquencyCollateralAssignment(collateralId, status) {
    return this.httpClient().patch(
      `${this.endpoint}/update-collateral-status`,
      { collateralId, status }
    );
  }

  
  updateDelinquencyCollateralAssignmentInformation(assignmentId, information) {
    return this.httpClient().put(
      `${this.endpoint}/${assignmentId}`,
      information
    );
  }

  /**
   * Use this when user wants to switch collateral assignment from Collector to Bailiff
   */
  unAssignDelinquencyCollateralAssignments(payload) {
    return this.httpClient().patch(
      `${this.endpoint}/deassign`,
      payload
    );
  }

  fetchDelinquentCollateralAssignmentReport(externalParticipantId) {
    return this.httpClient().get(`/delinquency-pro/app/external-participant-management/delinquency-collateral-assignment-report/${externalParticipantId}`)
  }
}